module.exports = __webpack_public_path__ + "img/4.441bb950.svg";